import { Link, Typography } from "@mui/material";

export function AuthFooter() {
    return (
        <Typography variant="body2" color="inherit" align="center">
            {'Copyright ©'}
            <Link color="inherit" href="https://www.motorsportireland.ie/">
                MotorSport Ireland
            </Link>{' '} 
            {new Date().getFullYear()}
        </Typography>
    );
}